import moment from "moment";
import { IBuilding, IScan } from "../../models/dashboard";
import { getRange } from "../../utils/dateUtils";

interface UseTimesheetProps {
    buildings: IBuilding[],
    start: Date | null,
    end : Date | null,
}

const UseTimesheet = ({buildings, start, end}:UseTimesheetProps) => {
    const buildingsCopy : IBuilding[] = JSON.parse(JSON.stringify(buildings));

    const allScans = buildingsCopy.reduce( (scans,building) => {
        building.locals.forEach( local => {
            scans.push(...local.scans)
        })
        return scans;
    },new Array<IScan>());

    const mergedScans = Array.from(allScans.reduce((acc, s) => {
        const key = moment(s.date).format("LL").concat(s.username);
        const scan = acc.get(key);
        if(scan){
            scan.time += s.time;
            acc.set(key,scan);
        }else{
            acc.set(key,s);
        }
        return acc;
    }, new Map<string,IScan>()).values());

    const userScans = new Map<string,number>();
    const userTotals = new Map<string,number>();
    const users = new Set<string>();

    const keyEncoder = (username: string, date : moment.Moment) => `${username}#${date.format("dddd, Do")}`
    
    mergedScans.forEach( mergedScan =>{
        const username = mergedScan.username;
        users.add(username);
        const key = keyEncoder(username,moment(mergedScan.date));
        userScans.set(key,mergedScan.time);
        userTotals.set(username, (userTotals.get(username) || 0 ) + mergedScan.time)
    });
    let dates = getRange(start as Date,end as Date,'days');

    return {
        dates,
        users, 
        userScans, 
        userTotals,
        keyEncoder
    }
}

export default UseTimesheet;